import { render, staticRenderFns } from "./ativosFixos.vue?vue&type=template&id=c68f7234&scoped=true&"
import script from "./ativosFixos.vue?vue&type=script&lang=js&"
export * from "./ativosFixos.vue?vue&type=script&lang=js&"
import style0 from "./ativosFixos.vue?vue&type=style&index=0&id=c68f7234&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68f7234",
  null
  
)

export default component.exports